import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Entity, Guard, Result, UniqueEntityID } from '@digibricks/core';
import { SubmissionReport } from '../submission';
import { GradedPercentage } from '@module/form';
import { DecimalNumber } from '../decimal-number'; //TODO: Model name should be changed to AttendeeSummary

export var Attendee = /*#__PURE__*/function (_Entity) {
  _inherits(Attendee, _Entity);

  var _super = _createSuper(Attendee);

  function Attendee() {
    _classCallCheck(this, Attendee);

    return _super.apply(this, arguments);
  }

  _createClass(Attendee, [{
    key: "firstName",
    get: function get() {
      return this.props.firstName;
    }
  }, {
    key: "lastName",
    get: function get() {
      return this.props.lastName;
    }
  }, {
    key: "email",
    get: function get() {
      return this.props.email;
    }
  }, {
    key: "report",
    get: function get() {
      return this.props.report;
    }
  }, {
    key: "toJsonObject",
    value: function toJsonObject() {
      return _objectSpread({}, this.props);
    }
  }, {
    key: "updateReport",
    value: function updateReport(updatedFields) {
      var submissionReportProps = _objectSpread(_objectSpread({}, this.props.report.toJsonObject()), updatedFields);

      var updatedSubmissionReport = SubmissionReport.create(submissionReportProps).getValue();
      this.props.report = updatedSubmissionReport;
    }
  }, {
    key: "updateScore",
    value: function updateScore(score) {
      var submissionReportProps = _objectSpread(_objectSpread({}, this.props.report.toJsonObject()), {}, {
        score: score
      });

      var updatedSubmissionReport = SubmissionReport.create(submissionReportProps).getValue();
      this.props.report = updatedSubmissionReport;
    }
  }, {
    key: "getNumberOfGradedAnswers",
    value: function getNumberOfGradedAnswers(totalAnswers) {
      var gradedPercentage = this.props.report.gradedPercentage;
      return gradedPercentage === GradedPercentage["default"] ? 0 : DecimalNumber.roundToInteger(gradedPercentage * totalAnswers / 100);
    }
  }], [{
    key: "create",
    value: function create(props) {
      var guardCollection = [{
        argument: props.firstName,
        argumentName: 'First Name'
      }, {
        argument: props.lastName,
        argumentName: 'Last Name'
      }, {
        argument: props.report,
        argumentName: 'Submission Report'
      }];
      var guardResult = Guard.againstNullOrUndefinedBulk(guardCollection);

      if (!guardResult.succeeded) {
        return Result.fail(guardResult.message);
      }

      return Result.ok(new Attendee(props, new UniqueEntityID(props.id.toString())));
    }
  }, {
    key: "fromJson",
    value: function fromJson(data) {
      try {
        var _DecimalNumber$roundT;

        var id = data.id,
            firstName = data.firstName,
            lastName = data.lastName,
            report = data.report,
            email = data.email;
        var reportOrError = SubmissionReport.create(_objectSpread(_objectSpread({}, report), {}, {
          score: report.score,
          gradedPercentage: (_DecimalNumber$roundT = DecimalNumber.roundToInteger(report.gradedPercentage)) !== null && _DecimalNumber$roundT !== void 0 ? _DecimalNumber$roundT : GradedPercentage["default"]
        }));

        if (reportOrError.isFailure) {
          return Result.fail(reportOrError.error);
        }

        return this.create({
          id: id,
          firstName: firstName,
          lastName: lastName,
          email: email,
          report: reportOrError.getValue()
        });
      } catch (error) {
        return Result.fail(error);
      }
    }
  }]);

  return Attendee;
}(Entity);